import { render, staticRenderFns } from "./AppearanceEditColorCategoryForm.vue?vue&type=template&id=33ee675b&scoped=true&"
import script from "./AppearanceEditColorCategoryForm.vue?vue&type=script&lang=js&"
export * from "./AppearanceEditColorCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ee675b",
  null
  
)

export default component.exports